/*
 * loadingReducer
 * Description
 * The reducer takes care of our data. Using actions, we can
 * update our application state. To add a new action,
 * add it to the switch statement in the reducer function
 *
 * @version 1.0.0
 * @author Pietro Bertuccelli
 * @since 04-Sep-2024
*/

import { produce } from 'immer'
import { actionTypes } from '../actions/loading'

const ACTION_HANDLERS = {
  [actionTypes.DO_LOCAL_LOADING]: produce((draft, action) => {
    draft.localLoading[action.payload.key] = action.payload.value
  })
  // @generator reducer:type:action

}

// The initial state of the loading
const initialState = {
  localLoading: {}
}

const loading = (state = initialState, action) => {
  const handler = ACTION_HANDLERS[action.type]
  return handler ? handler(state, action) : state
}

export default loading
